import { styled } from '@mui/system';

export const LinkNavigationContainer = styled('div')(() => ({
	marginTop: 30,
	display: 'flex',
	justifyContent: 'center',
	flexWrap: 'wrap'
}));
